export default __webpack_public_path__ + "static/Saira-Light-99fa699c19e6dea0f67f543afbe746d0.woff2";